// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2909) return "static/chunks/2909-e13f273267463e63.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6996 ? "d7d3521e" : chunkId) + "." + {"6996":"7ed684c26bc3d562","8598":"6ff6b05d2ec255db"}[chunkId] + ".js";
};